import React from "react"

import { Layout } from "../components/Layout/Layout"
import { ProjectsShowcase } from "../components/projects"
import { SEO } from "../components/Seo"

import "../styles/projects.css"

const ProjectsPage = () => (
  <Layout containerClass="projects-page-layout">
    <SEO
      title="Projeler"
      pathname="/projects/"
      image="/resim2.png"
    />
    <ProjectsShowcase />
  </Layout>
)

export default ProjectsPage
